import { render, staticRenderFns } from "./ReportCardViewerComponent.vue?vue&type=template&id=0b7a5d4c&"
import script from "./ReportCardViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ReportCardViewerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports